import { render, staticRenderFns } from "./OccupationArea.vue?vue&type=template&id=ec02453c"
import script from "./OccupationArea.vue?vue&type=script&lang=js"
export * from "./OccupationArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec02453c')) {
      api.createRecord('ec02453c', component.options)
    } else {
      api.reload('ec02453c', component.options)
    }
    module.hot.accept("./OccupationArea.vue?vue&type=template&id=ec02453c", function () {
      api.rerender('ec02453c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/register/OccupationArea.vue"
export default component.exports